/**
 * Product Variant Hover Images
 * This script handles showing the correct hover image for each product variant
 */
(function() {
  // Debug flag - set to true to enable console logs
  const DEBUG = true;
  
  function log(...args) {
    if (DEBUG) console.log(...args);
  }

  // Add transition styles to the document
  function addTransitionStyles() {
    // Check if our styles already exist
    if (document.getElementById('variant-hover-styles')) return;
    
    const styleElement = document.createElement('style');
    styleElement.id = 'variant-hover-styles';
    styleElement.textContent = `
      .t4s-product-img-main img,
      .t4s-product-img-hover img {
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
      }
      .t4s-img-switching {
        opacity: 0.5;
        transform: scale(0.98);
      }
    `;
    document.head.appendChild(styleElement);
    log('Added transition styles to document');
  }

  // Initialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    // DOM already loaded
    setTimeout(initializeAll, 500); // Add small delay to ensure other scripts have run
  }

  // Initialize again when page is fully loaded (for dynamic content)
  window.addEventListener('load', function() {
    setTimeout(initializeAll, 500);
  });

  function initializeAll() {
    log('Initializing product variant hover effects');
    addTransitionStyles();
    initVariantHoverImages();
    initColorSwatchListeners();

    // Also listen for variant changes
    document.addEventListener('variant:changed', function(event) {
      if (event.detail && event.detail.variant) {
        updateProductImages(event.detail.variant.id);
      }
    });
    
    // Setup a mutation observer to watch for dynamically added content
    setupMutationObserver();
  }

  /**
   * Setup mutation observer to watch for dynamically added product elements
   */
  function setupMutationObserver() {
    const observer = new MutationObserver(function(mutations) {
      let needsInit = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check if any new product color swatches were added
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && 
               (node.classList && 
                (node.classList.contains('t4s-product-colors') || 
                 node.querySelector('.t4s-product-colors')))) {
              needsInit = true;
            }
          });
        }
      });
      
      if (needsInit) {
        log('New product elements detected, reinitializing');
        initColorSwatchListeners();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  /**
   * Initialize hover effects for all products
   */
  function initVariantHoverImages() {
    // Add hover events to all product cards
    const productCards = document.querySelectorAll('.t4s-product-inner');
    log(`Found ${productCards.length} product cards`);
    
    productCards.forEach(card => {
      const productId = getProductIdFromWrapper(card);
      if (productId) {
        // Store original images
        const mainImg = card.querySelector('.t4s-product-img-main img');
        const hoverImg = card.querySelector('.t4s-product-img-hover img');
        if (mainImg && hoverImg) {
          card.dataset.originalMain = mainImg.getAttribute('data-src') || mainImg.src;
          card.dataset.originalHover = hoverImg.getAttribute('data-src') || hoverImg.src;
          log(`Stored original images for product ID: ${productId}`);
        }
      }
    });
  }

  /**
   * Initialize color swatch listeners
   */
  function initColorSwatchListeners() {
    // Find all color swatch containers
    const colorSwatchContainers = document.querySelectorAll('.t4s-product-colors');
    log(`Found ${colorSwatchContainers.length} color swatch containers`);
    
    colorSwatchContainers.forEach(container => {
      // Find parent product wrapper
      const productWrapper = findProductWrapper(container);
      if (!productWrapper) {
        log('Could not find product wrapper for color swatches', container);
        return;
      }
      
      // Process color options data
      try {
        const colorOptionsAttr = container.getAttribute('data-color-options');
        log('Color options attribute:', colorOptionsAttr);
        
        if (!colorOptionsAttr) {
          log('No color options found for container:', container);
          return;
        }
        
        const colorOptions = JSON.parse(colorOptionsAttr);
        log('Parsed color options:', colorOptions);
        
        if (!colorOptions || !colorOptions.id_variants || !colorOptions.id_variants.length) {
          log('Invalid or empty color options');
          return;
        }
        
        // Get all color dots in this container
        const colorDots = container.querySelectorAll('.t4s-pr-color__item');
        log(`Found ${colorDots.length} color dots, ${colorOptions.id_variants.length} variants`);
        
        // Add variant IDs to color dots and ensure they're visible
        colorDots.forEach((dot, index) => {
          if (index < colorOptions.id_variants.length) {
            const variantId = colorOptions.id_variants[index];
            dot.setAttribute('data-variant-id', variantId);
            
            // Ensure color value element has appropriate styling
            const colorValue = dot.querySelector('.t4s-pr-color__value');
            if (colorValue && colorValue.classList.contains('bg_color_ntloading')) {
              colorValue.classList.remove('bg_color_ntloading');
            }
            
            log(`Set variant ID ${variantId} for color dot ${index}`);
          }
        });
        
        // Add event listeners
        addColorDotsListeners(colorDots, productWrapper);
        
      } catch (error) {
        console.error('Error initializing color swatches:', error);
      }
    });
  }

  /**
   * Find the product wrapper from a child element
   */
  function findProductWrapper(element) {
    // Try multiple parent selectors for flexibility
    const wrapper = 
      element.closest('.t4s-product-inner') || 
      element.closest('.t4s-product-wrapper') ||
      element.closest('.t4s-product');
    
    return wrapper;
  }

  /**
   * Add event listeners to color dots
   */
  function addColorDotsListeners(colorDots, productWrapper) {
    // Get initially selected dot
    const initialSelectedDot = Array.from(colorDots).find(dot => 
      dot.classList.contains('is-swatch--selected') || 
      dot.classList.contains('is-selected')
    );
    
    colorDots.forEach(dot => {
      // Remove existing event listeners (clone and replace to ensure clean state)
      const newDot = dot.cloneNode(true);
      dot.parentNode.replaceChild(newDot, dot);
      
      // Add mouseenter event
      newDot.addEventListener('mouseenter', function(e) {
        const variantId = this.getAttribute('data-variant-id');
        const productId = getProductIdFromWrapper(productWrapper);
        
        log(`Mouse enter on color dot. Variant ID: ${variantId}, Product ID: ${productId}`);
        
        if (variantId && productId) {
          // Update images
          updateProductImages(variantId, productId);
          
          // Visually select this color dot
          colorDots.forEach(d => {
            d.classList.remove('is-swatch--selected');
            d.classList.remove('is-selected');
          });
          this.classList.add('is-swatch--selected');
          this.classList.add('is-selected');
          
          // Trigger variant:changed event
          const variantChangedEvent = new CustomEvent('variant:changed', {
            detail: { variant: { id: variantId } },
            bubbles: true
          });
          this.dispatchEvent(variantChangedEvent);
          
          log('Color dot selected on hover and event triggered');
        }
      });
      
      // We're no longer using mouseleave since we want the selection to persist
      
      // Add click event for compatibility with other scripts
      newDot.addEventListener('click', function(e) {
        // The color is already selected from hover, so this is just for compatibility
        // with other possible scripts that might be listening for clicks
        
        const variantId = this.getAttribute('data-variant-id');
        log(`Click on color dot (already selected from hover). Variant ID: ${variantId}`);
      });
    });
    
    // If no color dot is selected initially, select the first one
    if (!initialSelectedDot && colorDots.length > 0) {
      const firstDot = colorDots[0];
      const variantId = firstDot.getAttribute('data-variant-id');
      const productId = getProductIdFromWrapper(productWrapper);
      
      if (variantId && productId) {
        // Update images
        updateProductImages(variantId, productId);
        
        // Visually select first dot
        firstDot.classList.add('is-swatch--selected');
        firstDot.classList.add('is-selected');
        
        log('First color dot selected automatically');
      }
    }
  }

  /**
   * Get product ID from wrapper element
   */
  function getProductIdFromWrapper(wrapper) {
    if (!wrapper) return null;
    
    // Try multiple methods to find the product ID
    
    // 1. Try to find product ID in variant-images element
    const variantImages = wrapper.querySelector('.variant-images');
    if (variantImages && variantImages.dataset.productId) {
      log('Found product ID in variant-images:', variantImages.dataset.productId);
      return variantImages.dataset.productId;
    }
    
    // 2. Try to find in product options data
    const productElement = wrapper.closest('[data-product-options]') || wrapper;
    if (productElement && productElement.getAttribute('data-product-options')) {
      try {
        const productOptions = JSON.parse(productElement.getAttribute('data-product-options') || '{}');
        if (productOptions.id) {
          log('Found product ID in data-product-options:', productOptions.id);
          return productOptions.id;
        }
      } catch (e) {
        console.error('Error parsing product options:', e);
      }
    }
    
    // 3. Try to extract from CSS classes
    if (wrapper.classList) {
      for (const className of wrapper.classList) {
        if (className.startsWith('t4s-pr-')) {
          const possibleId = className.replace('t4s-pr-', '');
          if (!isNaN(possibleId)) {
            log('Found product ID in class name:', possibleId);
            return possibleId;
          }
        }
      }
    }
    
    // 4. Look at parent elements
    const parentProduct = wrapper.closest('.t4s-product');
    if (parentProduct) {
      return getProductIdFromWrapper(parentProduct);
    }
    
    log('Could not find product ID for wrapper:', wrapper);
    return null;
  }

  /**
   * Update product images based on variant
   */
  function updateProductImages(variantId, productId) {
    log(`Updating images for variant ID: ${variantId}, product ID: ${productId}`);
    
    // Find the product wrapper that contains this product
    let productWrapper = null;
    
    // Try multiple selectors to find the product
    const selectors = [
      `.variant-images[data-product-id="${productId}"]`,
      `.t4s-pr-${productId}`,
      `.t4s-pr-${productId} .t4s-product-inner`,
      `.t4s-pr-${productId} .t4s-product-wrapper`
    ];
    
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        productWrapper = element.closest('.t4s-product-inner') || element.closest('.t4s-product-wrapper') || element;
        log(`Found product wrapper using selector: ${selector}`);
        break;
      }
    }
    
    if (!productWrapper) {
      log('Could not find product wrapper');
      return;
    }

    // Find the variant image set
    const variantImageSet = productWrapper.querySelector(`.variant-image-set[data-variant-id="${variantId}"]`);
    if (!variantImageSet) {
      log('Could not find variant image set');
      return;
    }

    const mainImg = productWrapper.querySelector('.t4s-product-img-main img');
    const hoverImg = productWrapper.querySelector('.t4s-product-img-hover img');
    
    if (!mainImg || !hoverImg) {
      log('Could not find main or hover images');
      return;
    }
    
    const newMainImgUrl = variantImageSet.querySelector('.variant-main').getAttribute('data-img-url');
    const newHoverImgUrl = variantImageSet.querySelector('.variant-hover').getAttribute('data-img-url');
    
    log('New image URLs:', { main: newMainImgUrl, hover: newHoverImgUrl });
    
    // Add transition class to indicate switch is happening
    mainImg.classList.add('t4s-img-switching');
    hoverImg.classList.add('t4s-img-switching');
    
    // Wait for transition to start before changing the images
    setTimeout(() => {
      if (newMainImgUrl) {
        mainImg.src = newMainImgUrl;
        if (mainImg.hasAttribute('data-src')) mainImg.setAttribute('data-src', newMainImgUrl);
      }
      
      if (newHoverImgUrl) {
        hoverImg.src = newHoverImgUrl;
        if (hoverImg.hasAttribute('data-src')) hoverImg.setAttribute('data-src', newHoverImgUrl);
      }
      
      // Remove the transition class after images have changed
      setTimeout(() => {
        mainImg.classList.remove('t4s-img-switching');
        hoverImg.classList.remove('t4s-img-switching');
        log('Images updated successfully with transition');
      }, 50);
    }, 150);
  }

  /**
   * Reset product images to original
   * Note: This function is kept for potential future use but is no longer used
   * in the main flow since we want selections to persist.
   */
  function resetProductImages(productId) {
    log(`Resetting images for product ID: ${productId}`);
    
    // Find the product wrapper that contains this product
    let productWrapper = null;
    
    // Try multiple selectors to find the product
    const selectors = [
      `.variant-images[data-product-id="${productId}"]`,
      `.t4s-pr-${productId}`,
      `.t4s-pr-${productId} .t4s-product-inner`,
      `.t4s-pr-${productId} .t4s-product-wrapper`
    ];
    
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        productWrapper = element.closest('.t4s-product-inner') || element.closest('.t4s-product-wrapper') || element;
        log(`Found product wrapper for reset using selector: ${selector}`);
        break;
      }
    }

    if (!productWrapper) {
      log('Could not find product wrapper for reset');
      return;
    }

    const mainImg = productWrapper.querySelector('.t4s-product-img-main img');
    const hoverImg = productWrapper.querySelector('.t4s-product-img-hover img');
    
    if (!mainImg || !hoverImg) {
      log('Could not find images for reset');
      return;
    }
    
    // Add transition class before resetting
    mainImg.classList.add('t4s-img-switching');
    hoverImg.classList.add('t4s-img-switching');
    
    // Wait for transition to start before changing the images back
    setTimeout(() => {
      if (mainImg && productWrapper.dataset.originalMain) {
        log('Resetting main image to:', productWrapper.dataset.originalMain);
        mainImg.src = productWrapper.dataset.originalMain;
        if (mainImg.hasAttribute('data-src')) mainImg.setAttribute('data-src', productWrapper.dataset.originalMain);
      }
      
      if (hoverImg && productWrapper.dataset.originalHover) {
        log('Resetting hover image to:', productWrapper.dataset.originalHover);
        hoverImg.src = productWrapper.dataset.originalHover;
        if (hoverImg.hasAttribute('data-src')) hoverImg.setAttribute('data-src', productWrapper.dataset.originalHover);
      }
      
      // Remove the transition class after images have changed back
      setTimeout(() => {
        mainImg.classList.remove('t4s-img-switching');
        hoverImg.classList.remove('t4s-img-switching');
        log('Images reset successfully with transition');
      }, 50);
    }, 150);
  }
})(); 